<script>
  import { Route, useNavigate } from "svelte-navigator";
  import {
    PROCESSREGISTRATION_SUBROUTES,
    ROUTES,
  } from "../../../../lib/util/routes.js";
  import { useUrlParams } from "@stores/urlStore.js";
  import ProcessOverview from "./ProcessOverview.svelte";
  import ProcessCheck from "./ProcessCheck.svelte";
  import TaskExplorer from "./TaskExplorer.svelte";
  import Dashboard from "./Dashboard.svelte";
  import CaseIdMapper from "./CaseidMapper.svelte";
  import { SvelteFlowProvider } from "@xyflow/svelte";
  import { activitiesStoreProject } from "@stores/projectStores.js";
  import AnonymizationReview from "./AnonymizationReview.svelte";

  const navigate = useNavigate();
  const urlParams = useUrlParams();
  let redirected = false;

  $: ({ idproject } = $urlParams);
  $: hasRequiredParams = Boolean(idproject);

  const { getAllActivities } = activitiesStoreProject;
  $: if (!hasRequiredParams && !redirected) {
    redirected = true;
    Promise.resolve(navigate(ROUTES.dam.root, { replace: true })).catch(() => {
      window.location.replace(ROUTES.dam.root);
    });
  }
  $: if (hasRequiredParams) {
    getStoreData();
  }

  async function getStoreData() {
    getAllActivities(idproject);
  }

  $$restProps;
</script>

{#if hasRequiredParams}
  <Route path={PROCESSREGISTRATION_SUBROUTES.dashboard}
    ><Dashboard {idproject} /></Route
  >
  <Route path={PROCESSREGISTRATION_SUBROUTES.overview}>
    <SvelteFlowProvider>
      <ProcessOverview />
    </SvelteFlowProvider>
  </Route>
  <Route path={PROCESSREGISTRATION_SUBROUTES.check}><ProcessCheck /></Route>
  <Route path={PROCESSREGISTRATION_SUBROUTES.taskExplorer}>
    <SvelteFlowProvider>
      <TaskExplorer />
    </SvelteFlowProvider>
  </Route>
  <Route path={PROCESSREGISTRATION_SUBROUTES.caseIdMapper}
    ><CaseIdMapper /></Route
  >
  <Route path={PROCESSREGISTRATION_SUBROUTES.anonymizationCheck}
    ><AnonymizationReview /></Route
  >
{/if}
